import { BACKEND_BASE } from "@/lib/backend";

export const DEFAULT_BRAND_LOGO = "/brand/logo-icon.png?v=2";
/** Text-only wordmark PNG (no logo icon inside the file). */
export const DEFAULT_FOOTER_WORDMARK = "/brand/logo-wordmark-text.png";
/** Logo icon slot — wordmark matches the same height, width follows image ratio. */
export const BRAND_LOGO_SLOT_CLASS = {
  sm: "h-9 w-9",
  md: "h-10 w-10",
  lg: "h-12 w-12",
};

export function resolveBrandLogoUrl(mediaLogo) {
  if (!mediaLogo) return DEFAULT_BRAND_LOGO;
  if (mediaLogo.startsWith("http") || mediaLogo.startsWith("/")) return mediaLogo;
  return `${BACKEND_BASE}${mediaLogo}`;
}

export function resolveFooterWordmarkUrl(mediaFooterWordmark) {
  if (!mediaFooterWordmark) return DEFAULT_FOOTER_WORDMARK;
  if (mediaFooterWordmark.startsWith("http") || mediaFooterWordmark.startsWith("/")) {
    return mediaFooterWordmark;
  }
  return `${BACKEND_BASE}${mediaFooterWordmark}`;
}
